// Tailwind/CVA-styled button primitive. Pure styled wrapper; no data
// dependencies. Postgres mapping and integration hook: not applicable.
import * as React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from './lib';

const buttonVariants = cva(
    'tw-inline-flex tw-items-center tw-justify-center tw-gap-2 tw-rounded-md tw-text-xs tw-font-semibold tw-transition-all tw-duration-150 focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-[var(--text)] disabled:tw-pointer-events-none disabled:tw-opacity-50 tw-font-[Inter,sans-serif] tw-cursor-pointer active:tw-scale-[0.97]',
    {
        variants: {
            variant: {
                default: 'tw-bg-[var(--text)] tw-text-[var(--bg)] hover:tw-opacity-90 tw-border-0',
                outline: 'tw-border tw-border-[var(--border2)] tw-bg-transparent tw-text-[var(--muted)] hover:tw-text-[var(--text)] hover:tw-border-[var(--text)]',
                ghost: 'tw-bg-transparent tw-text-[var(--muted)] hover:tw-text-[var(--text)] tw-border tw-border-[var(--border2)] hover:tw-border-[var(--text)]',
                teal: 'tw-border tw-border-[var(--border2)] tw-text-[var(--text)] tw-bg-transparent hover:tw-bg-[var(--text)] hover:tw-text-[var(--bg)] hover:tw-border-[var(--text)]',
                destructive: 'tw-bg-[var(--red)] tw-text-white hover:tw-opacity-90 tw-border-0',
                pill: 'tw-rounded-full tw-border tw-border-[var(--border2)] tw-bg-transparent tw-text-[var(--muted)] hover:tw-text-[var(--text)] hover:tw-border-[var(--dim)]',
                pillActive: 'tw-rounded-full tw-bg-[var(--text)] tw-text-[var(--bg)] tw-border tw-border-[var(--text)]',
            },
            size: {
                default: 'tw-px-3 tw-py-1.5',
                sm: 'tw-px-2.5 tw-py-1',
                lg: 'tw-px-4 tw-py-2',
                icon: 'tw-h-7 tw-w-7',
            },
        },
        defaultVariants: {
            variant: 'default',
            size: 'default',
        },
    }
);

const Button = React.forwardRef(({ className, variant, size, ...props }, ref) => (
    <button ref={ref} className={cn(buttonVariants({ variant, size }), className)} {...props} />
));
Button.displayName = 'Button';

export { Button, buttonVariants };
